import * as API from '../'
import $const from '@/common/constant.js'
export default {
  //获取题目
  getQuestionsLibrary: params => {
    return API.POST($const.apiServer.Tranning + '/in-class-test-c/getQuestionsLibrary', params);
  },
  //获取题目
  answer: params => {
    return API.POST($const.apiServer.Tranning + '/in-class-test-record-c/answer', params);
  },
  //获取记录
  queryList: params => {
    return API.POST($const.apiServer.Tranning + '/in-class-test-record-c/queryList', params);
  },





}



// WEBPACK FOOTER //
// ./src/api/yjt/api_class_test.js